import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  UpdateCategory,
} from "../../../redux/services/categoriesService/categories.Services";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";


function EditCategory({ data, onSuccess }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
     description: "",
    status: true,
  });
//   const handleDescriptionChange = (event, editor) => {
//   const data = editor.getData();
//   setFormData((prev) => ({ ...prev, description: data }));
 
// };
  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
         description: data.description || "",
        status:
          data.status === 1 ||
          data.status === true,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "status"
          ? value === "Active"
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const payload = {
        id: data?.id,
        name: formData.name,
          description: formData.description,
        status: formData.status ? 1 : 0,
      };

      const res = await UpdateCategory(payload);
      successToast(
      res?.data?.message 
    );
      // if (onSuccess) {
      //   await onSuccess();
      // }
       dispatch(refreshProductList());

    // Close Product Modal
    dispatch(closeProductModal());



    } catch (err) {
      console.log(err);

        errorToast(
      err?.response?.data?.message || "Error updating category"
    );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">

      <form
        onSubmit={handleSubmit}
        className="row"
      >

        <div className="col-md-12">
          <label>Category Name</label>

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter role name"
          />
        </div>
 
 
        <div className="col-md-12">
          <label>Status</label>

          <select
            name="status"
            value={
              formData.status
                ? "Active"
                : "Inactive"
            }
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">
              Active
            </option>

            <option value="Inactive">
              Inactive
            </option>
          </select>
        </div>
{/*<div className="col-md-12">
  <label>Category Description</label>

  <CKEditor
    editor={ClassicEditor}
    data={formData.description}
    onChange={handleDescriptionChange}
    config={{
      placeholder: "Enter category description...",
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "blockQuote",
        "|",
        "undo",
        "redo",
      ],
    }}
  />
</div>*/}



 <div className="col-md-12">
  <label>Category Description</label>

  <textarea
    name="description"
    rows="5"
    value={formData.description}
    onChange={handleChange}
    className="form-control"
    placeholder="Enter category description..."
  />
</div> 



        <div className="col-md-12 text-end">
          <button
            type="submit"
            disabled={isLoading}
            className="add-btn"
          >
            {isLoading
              ? "Updating..."
              : "Update Category"}
          </button>
        </div>

      </form>

    </div>
  );
}

export default EditCategory;